export const app_created_at_after = "app_created_at_after";
export const app_created_at_before = "app_created_at_before";
export const geo_created_at_before = "geo_created_at_before";
export const geo_created_at_after = "geo_created_at_after";
export const clients_created_at_after = "clients_created_at_after";
export const clients_created_at_before = "clients_created_at_before";
export const categories_created_at_after = "categories_created_at_after";
export const categories_created_at_before = "categories_created_at_before";

export const dashboardParams = {
    app_created_at_after,
    app_created_at_before,
    geo_created_at_before,
    geo_created_at_after,
    clients_created_at_after,
    clients_created_at_before,
    categories_created_at_after,
    categories_created_at_before
};
